import columns from '../../../../../../react-table/helpers/columns';

export const receptacleTypePredesResdesConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if ((rowInfo.row['receptacleType.predes'] !== null) && (rowInfo.row['receptacleType.resdes'] !== null) &&
      (rowInfo.row['receptacleType.predes'] !== rowInfo.row['receptacleType.resdes'])) {
      className = 'text-red';
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacleId').withWidth(300)),
        new DateTimeColumn('Close date', 'closeDate'),
        new DateTimeColumn('RESDES event date', 'resdesEventDate'),
      ],
    },
    {
      Header: 'Receptacle type',
      columns: [
        new TextColumn('PREDES', 'receptacleType.predes').withGetProps(receptacleTypePredesResdesConditionalProps),
        new TextColumn('RESDES', 'receptacleType.resdes').withGetProps(receptacleTypePredesResdesConditionalProps),
      ],
    },
  ];
};
